import { Link } from "react-router-dom";
import { AuthLayout } from "./AuthLayout";
import { MailCheck } from "lucide-react";

export const VerifyEmailNotice = ({ email, testId = "verify-email-notice" }) => (
  <AuthLayout title="Check your inbox" subtitle="One quick step to activate your account." testId={testId}>
    <div className="rounded-md border border-accent/30 bg-emerald-50 p-6" data-testid={`${testId}-card`}>
      <div className="flex items-start gap-3">
        <MailCheck className="mt-0.5 h-6 w-6 shrink-0 text-accent" />
        <div>
          <p className="font-medium text-slate-900">Verify your email to continue</p>
          <p className="mt-1 text-sm text-slate-600">
            We've sent a confirmation link to <span className="font-medium">{email || "your email"}</span>.
            Click it to verify your account — you'll then be taken to the sign-in page.
          </p>
        </div>
      </div>
    </div>
    <p className="mt-6 text-center text-sm text-slate-500">
      Already verified?{" "}
      <Link to="/login" className="font-medium text-primary hover:underline" data-testid={`${testId}-login-link`}>
        Go to sign in
      </Link>
    </p>
  </AuthLayout>
);
